<template>
  <v-container>

    <v-dialog v-if="lottiDialog" v-model="lottiDialog" width="400">
      <v-card>
        <v-card-title>
          {{ lotti }}
        </v-card-title>
        <v-card-text>
          <v-page-data-table
              :fields="sizePackingFields"
              :show-edit="false"
              dense
              hide-footer
              hide-search
              hide-toolbar
              ref="sizePacking"
              hide-row-action
              key-name="id"
              query-api="SIZE_PACKING_LIST_QUERY"
              :query-params="{sizePackingId:sizePackingId}">
          </v-page-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="lottiDialog=false"
                 color="primary" tile>OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="scanedDialog" v-model="scanedDialog" width="800">
      <v-card>
        <v-card-title>
          {{ boxCode }}
        </v-card-title>
        <v-card-text>
          <v-page-data-table
              :fields="boxScanedFields"
              :show-edit="false"
              dense
              hide-footer
              hide-search
              hide-toolbar
              ref="scanedDialog"
              hide-row-action
              key-name="id"
              query-api="BOX_PIECE_QUERY"
              :query-params="{boxId:boxId,scaned:pieceScaned}">
            <template v-slot:match="{item}">
              <v-btn text tile color="success" small v-if="item.scaned==1">
                <v-icon small>mdi-checkbox-marked-circle</v-icon>
              </v-btn>
              <v-btn text tile color="warning" small v-else-if="item.scaned==0">
                <v-icon color="red" small>mdi-close-circle</v-icon>
              </v-btn>
            </template>
          </v-page-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="scanedDialog=false"
                 color="primary" tile>OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="repackingDialog" v-model="repackingDialog" width="600">
      <v-card>
        <v-card-title>
          Edit RePacking Information
        </v-card-title>
        <v-card-text>
          <v-form-field
              x-large
              autofocus
              v-model="repackInfo.style"
              label="Style"></v-form-field>
          <v-form-field
              x-large
              v-model="repackInfo.color"
              label="Color"></v-form-field>
          <v-form-field
              x-large
              v-model="repackInfo.size"
              label="Size"></v-form-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :loading="$store.getters.loading['BOX_REPACKING']" @click="repacking"
                 color="primary" tile>RePacking
          </v-btn>
          <v-btn @click="repackingDialog=false" outlined tile>CANCEL
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="noScanDialog" v-model="noScanDialog" width="600">
      <v-card>
        <v-card-title>
          NO SCAN CODE
        </v-card-title>
        <v-card-text>
          <v-form-field
              x-large
              autofocus
              v-model="noScanStyle"
              label="Style"></v-form-field>
          <v-form-field
              x-large
              v-model="noScanColor"
              label="Color"></v-form-field>
          <v-form-field
              x-large
              v-model="noScanSize"
              label="Size"></v-form-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn  @click="noScanDialog=false;barcodeDialog=true;"
                 color="primary" tile>OK
          </v-btn>
          <v-btn @click="noScanDialog=false;" outlined tile>CANCEL
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="barcodeDialog" v-model="barcodeDialog" width="400">
      <v-card>
        <v-card-title>
          NoScanBarcode
        </v-card-title>
        <v-card-text>
          <v-page-data-table
              :fields="noScanBarcodeFields"
              :show-edit="false"
              dense
              hide-footer
              hide-search
              hide-toolbar
              ref="barcode"
              hide-row-action
              key-name="id"
              query-api="NO_SCAN_BARCODE_QUERY"
              :query-params="{poId:docId,style:noScanStyle,color:noScanColor,size:noScanSize}">
          </v-page-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="barcodeDialog=false"
                 color="primary" tile>OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-simple-form title="Container Info">
      <template v-slot:toolbar>
        <v-btn @click="goBack" color="rgba(0,0,0,.7)" small text tile>
          <v-icon color="gray">mdi-step-backward</v-icon>
          Back
        </v-btn>
        <v-btn v-if="isAdmin" @click="editDialog=true;" color="rgba(0,0,0,.7)" small text tile>
          <v-icon color="gray">mdi-square-edit-outline</v-icon>
          Edit
        </v-btn>
        <v-spacer/>
      </template>
      <template v-slot:content>
        <v-row no-gutters>
          <v-col :cols="3">
            <v-form-field label="PO No" :text="doc.po" readonly middle></v-form-field>
          </v-col>
          <v-col :cols="3">
            <v-form-field label="Factory" :text="doc.factoryName" readonly middle></v-form-field>
          </v-col>
          <v-col :cols="3">
            <v-form-field label="Total Cartons" :text="doc.boxQuantity" readonly middle></v-form-field>
          </v-col>
          <v-col :cols="3">
            <v-form-field label="Total Pieces" :text="doc.pieceQuantity" readonly middle></v-form-field>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col :cols="3">
            <v-form-field label="Scaned" :text="scaned" readonly middle></v-form-field>
          </v-col>
          <v-col :cols="3">
            <v-form-field label="Unscan" :text="unScaned" readonly middle></v-form-field>
          </v-col>
          <v-col :cols="3">
            <v-form-field label="Status" :text="doc.boxStatus" readonly middle></v-form-field>
          </v-col>
        </v-row>

      </template>
    </v-simple-form>
    <v-simple-form title="Items">
      <template v-slot:toolbar>
        <v-btn @click="onShowNoMatch" color="rgba(0,0,0,.7)" small text tile>
          <v-icon small color="gray">mdi-close-box-multiple</v-icon>
          Show No Scan
        </v-btn>
        <v-btn @click="repackingDialog=true;" color="rgba(0,0,0,.7)" small text tile>
          <v-icon color="gray">mdi-square-edit-outline</v-icon>
          RePacking
        </v-btn>

        <v-btn @click="noScanDialog=true;" color="rgba(0,0,0,.7)" small text tile>
          <v-icon color="gray">mdi-database-search</v-icon>
          No Scan Code
        </v-btn>

        <v-spacer/>
        <v-text-field class="vc-input__border mr-5" solo flat dense hide-details
                      clearable
                      @keydown="onSearchMaterial"
                      v-model="searchText">
        </v-text-field>
      </template>
      <template v-slot:content>
        <v-page-data-table
            :fields="processHistoryFields"
            :show-edit="false"
            hide-toolbar
            ref="material"
            hide-row-action
            key-name="id"
            query-api="BOX_QUERY"
            :query-params="{orderId:docId,showNoMatch:showNoMatch,text:searchText}">
          <template v-slot:match="{item}">
            <v-btn text tile color="success" small v-if="item.status=='FN'">
              <v-icon small>mdi-checkbox-marked-circle</v-icon>
            </v-btn>
            <v-btn text tile color="warning" small v-else-if="item.status=='OP'">
              <v-icon color="red" small>mdi-close-circle</v-icon>
            </v-btn>
          </template>

          <template v-slot:size="{item}">
            <v-btn @click="showSizePackingDialog(item.sizePackingId,item.size)" text tile color="blue" small
                   v-if="item.isMix=='1'">
              {{ item.size }}
            </v-btn>
            <p v-else>{{ item.size }}</p>
          </template>
          <!--          <template v-slot:pieceScaned="{item}">-->
          <!--            <v-btn @click="showScanedDialog(item.id,item.sscCode)" text tile color="blue" small-->
          <!--                   v-if="item.pieceScaned>0">-->
          <!--              {{ item.pieceScaned }}-->
          <!--            </v-btn>-->
          <!--            <p v-else>{{ item.pieceScaned }}</p>-->
          <!--          </template>-->
          <template v-slot:realPiece="{item}">
            <v-btn @click="showQuantityDialog(item.id,item.sscCode)" text tile color="blue" small>
              {{ item.realPiece }}
            </v-btn>
          </template>
        </v-page-data-table>
      </template>
    </v-simple-form>
  </v-container>
</template>

<script>

import BoxDetailFields from './fields/BoxDetailFields'
import SizePackingFields from './fields/SizePackingFields'
import BoxScanedFields from './fields/BoxScanedFields'
import NoScanBarcodeFields from './fields/NoScanBarcodeFields'

export default {
  name: "ProjectDetail.vue",
  data() {
    return {
      docId: null,
      mixNumberDialog: false,
      scanedDialog: false,
      barcodeDialog: false,
      mixNumber: null,
      style: null,
      color: null,
      noScanDialog: false,
      noScanStyle: null,
      noScanSize: null,
      noScanColor: null,
      searchText: null,
      editDialog: false,
      repackingDialog: false,
      lottiDialog: false,
      keyText: null,
      lotti: null,
      processHistoryFields: BoxDetailFields,
      sizePackingFields: SizePackingFields,
      boxScanedFields: BoxScanedFields,
      noScanBarcodeFields: NoScanBarcodeFields,
      sizePackingId: null,
      boxId: null,
      pieceScaned: 0,
      boxCode: null,
      isAdmin: false,
      doc: {
        po: null,
        boxQuantity: null,
        factoryName: null,
        pieceQuantity: null,
        boxStatus: null,
        boxScaned: "",
        pieceScaned: ""
      },
      repackInfo: {
        poId: null,
        style: null,
        size: null,
        color: null
      },
      showNoMatch: false,
      showNoNumber: false
    }
  },
  computed: {
    statusMeaning: function () {
      let meaning = "";
      if (this.doc.status == 'OP') {
        meaning = "OPEN";
      } else if (this.doc.status == 'PK') {
        meaning = "LOADING";
      } else if (this.doc.status == "FN") {
        meaning = "DONE";
      }
      return meaning;
    },
    scaned: function () {
      return this.doc.boxScaned + "/" + this.doc.pieceScaned;
    },
    unScaned: function () {
      if (!this.doc.boxQuantity) {
        return "";
      }
      return (this.doc.boxQuantity - this.doc.boxScaned) + "/" + (this.doc.pieceQuantity - this.doc.pieceScaned);
    }
  },
  created() {
    this.docId = this.$route.query.id;
    if (this.docId) {
      this.queryDetail(this.docId);
    }
    this.isAdmin = this.$tool.hasRole("SMS_ADMIN");
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onShowNoMatch() {
      this.showNoNumber = false;
      this.showNoMatch = true;
      this.$refs.material.query();
    },
    onShowNoNumber() {
      this.showNoMatch = false;
      this.showNoNumber = true;
      this.$refs.material.query();
    },
    queryDetail(id) {
      this.$request
          .request("ORDER_DETAIL", {id: id})
          .then(response => {
            this.doc = Object.assign(this.doc, response.data);
          });
    },
    showScanedDialog(boxId, boxCode) {
      this.boxId = boxId;
      this.boxCode = boxCode;
      this.scanedDialog = true;
      this.pieceScaned = 1;
    },
    showQuantityDialog(boxId, boxCode) {
      this.boxId = boxId;
      this.boxCode = boxCode;
      this.scanedDialog = true;
      this.pieceScaned = null;
    },
    showSizePackingDialog(sizePackingId, size) {
      this.sizePackingId = sizePackingId;
      this.lotti = size;
      this.lottiDialog = true;
    },
    updateContainer() {
      this.$request
          .request("CONTAINER_UPDATE", this.doc)
          .then(response => {
            this.$message.success("更新成功");
            this.editDialog = false;
          });
    },
    onSearchMaterial(e) {
      if (e.keyCode === 13) {
        this.showNoNumber = false;
        this.showNoMatch = false;
        this.$refs.material.query();
      }
    },
    repacking() {
      this.repackInfo.poId = this.docId;
      this.$request
          .request("BOX_REPACKING", this.repackInfo)
          .then(response => {
            this.$message.success("总共成功完成" + response.data + "个箱子翻箱操作");
            this.repackInfo.style = null;
            this.repackInfo.color = null;
            this.repackInfo.size = null;
            this.repackingDialog = false;
            this.$refs.material.query();
          });
    }
  },
}
</script>
